export * from './adminSignUpController.service';
import { AdminSignUpControllerService } from './adminSignUpController.service';
export * from './applicationStatusController.service';
import { ApplicationStatusControllerService } from './applicationStatusController.service';
export * from './assetDataSyncController.service';
import { AssetDataSyncControllerService } from './assetDataSyncController.service';
export * from './assetSelectionController.service';
import { AssetSelectionControllerService } from './assetSelectionController.service';
export * from './basicErrorController.service';
import { BasicErrorControllerService } from './basicErrorController.service';
export * from './broadcastSearchController.service';
import { BroadcastSearchControllerService } from './broadcastSearchController.service';
export * from './configurationController.service';
import { ConfigurationControllerService } from './configurationController.service';
export * from './custQuotOtpController.service';
import { CustQuotOtpControllerService } from './custQuotOtpController.service';
export * from './customerSignupController.service';
import { CustomerSignupControllerService } from './customerSignupController.service';
export * from './customerTypeCodeController.service';
import { CustomerTypeCodeControllerService } from './customerTypeCodeController.service';
export * from './dealerUploadController.service';
import { DealerUploadControllerService } from './dealerUploadController.service';
export * from './dealershipController.service';
import { DealershipControllerService } from './dealershipController.service';
export * from './docMasterController.service';
import { DocMasterControllerService } from './docMasterController.service';
export * from './emiCalculatorController.service';
import { EmiCalculatorControllerService } from './emiCalculatorController.service';
export * from './extCustomerInfoController.service';
import { ExtCustomerInfoControllerService } from './extCustomerInfoController.service';
export * from './faqController.service';
import { FaqControllerService } from './faqController.service';
export * from './financeController.service';
import { FinanceControllerService } from './financeController.service';
export * from './financeDataSyncController.service';
import { FinanceDataSyncControllerService } from './financeDataSyncController.service';
export * from './financeServiceController.service';
import { FinanceServiceControllerService } from './financeServiceController.service';
export * from './incomeTypeCodeController.service';
import { IncomeTypeCodeControllerService } from './incomeTypeCodeController.service';
export * from './indDlpLoginController.service';
import { IndDlpLoginControllerService } from './indDlpLoginController.service';
export * from './loanTypeCodeController.service';
import { LoanTypeCodeControllerService } from './loanTypeCodeController.service';
export * from './localityController.service';
import { LocalityControllerService } from './localityController.service';
export * from './localityDetailsController.service';
import { LocalityDetailsControllerService } from './localityDetailsController.service';
export * from './masterDataSyncAuditController.service';
import { MasterDataSyncAuditControllerService } from './masterDataSyncAuditController.service';
export * from './masterDataSyncController.service';
import { MasterDataSyncControllerService } from './masterDataSyncController.service';
export * from './ndSysConfigController.service';
import { NdSysConfigControllerService } from './ndSysConfigController.service';
export * from './notificationController.service';
import { NotificationControllerService } from './notificationController.service';
export * from './personalInfoController.service';
import { PersonalInfoControllerService } from './personalInfoController.service';
export * from './phoneController.service';
import { PhoneControllerService } from './phoneController.service';
export * from './preapprovalController.service';
import { PreapprovalControllerService } from './preapprovalController.service';
export * from './reviewController.service';
import { ReviewControllerService } from './reviewController.service';
export * from './searchCustomerController.service';
import { SearchCustomerControllerService } from './searchCustomerController.service';
export * from './searchQuotController.service';
import { SearchQuotControllerService } from './searchQuotController.service';
export * from './welcomeController.service';
import { WelcomeControllerService } from './welcomeController.service';
export const APIS = [AdminSignUpControllerService, ApplicationStatusControllerService, AssetDataSyncControllerService, AssetSelectionControllerService, BasicErrorControllerService, BroadcastSearchControllerService, ConfigurationControllerService, CustQuotOtpControllerService, CustomerSignupControllerService, CustomerTypeCodeControllerService, DealerUploadControllerService, DealershipControllerService, DocMasterControllerService, EmiCalculatorControllerService, ExtCustomerInfoControllerService, FaqControllerService, FinanceControllerService, FinanceDataSyncControllerService, FinanceServiceControllerService, IncomeTypeCodeControllerService, IndDlpLoginControllerService, LoanTypeCodeControllerService, LocalityControllerService, LocalityDetailsControllerService, MasterDataSyncAuditControllerService, MasterDataSyncControllerService, NdSysConfigControllerService, NotificationControllerService, PersonalInfoControllerService, PhoneControllerService, PreapprovalControllerService, ReviewControllerService, SearchCustomerControllerService, SearchQuotControllerService, WelcomeControllerService];
